import gql from 'graphql-tag';

const GET_ALL_CATALOG_SPECS = gql`
  query allCatalogSpecs {
    catalogSpecs: getCatalogSpecs {
      id,
      label,
      name
    }
  }
`;

export default GET_ALL_CATALOG_SPECS;
